import { Stack, Text, VStack, chakra } from "@chakra-ui/react";
import { RedButton } from "./RedButton"; // We'll create this next
import { KYDAdminEvent, KYDEvent } from "@common/interfaces/KYDEvent"; // Adjust import path as needed

const ColoredText = chakra.span;

interface DangerZoneProps {
  kydEvent: KYDAdminEvent;
  onArchive: () => void;
  onCancel: () => void;
  onDelete: () => void;
  loading: boolean;
}

export const getActionDetails = (
  action: string,
  kydEvent: KYDAdminEvent,
  handlers: {
    onArchive: () => void;
    onCancel: () => void;
    onDelete: () => void;
  }
) => {
  switch (action) {
    case "ARCHIVE":
      return {
        title: "Archive Event",
        buttonText: "Archive Event",
        onClick: handlers.onArchive,
        content: (
          <>
            <Text w="full">
              The event {kydEvent?.name} is currently{" "}
              <ColoredText color="green" fontWeight={"bold"} mr={1}>
                live
              </ColoredText>
              with{" "}
              <ColoredText color="green" fontWeight={"bold"}>
                {kydEvent?.total_tickets_purchased}
              </ColoredText>{" "}
              tickets sold.
            </Text>
            <Text w="full" fontSize="sm">
              Event will be moved to archive and not visible to fans
            </Text>
          </>
        ),
      };
    case "CANCEL":
      return {
        title: "Cancel Event",
        buttonText: "Cancel Event",
        onClick: handlers.onCancel,
        content: (
          <>
            <Text w="full">
              The event {kydEvent?.name} is currently{" "}
              <ColoredText color="green" mr={1}>
                live
              </ColoredText>
              with{" "}
              <ColoredText color="green" fontWeight={"bold"}>
                {kydEvent?.total_tickets_purchased}
              </ColoredText>{" "}
              tickets sold.
            </Text>
            <Text w="full" fontSize="sm">
              This action results in{" "}
              <ColoredText fontWeight={"bold"} color="kydRed.200">
                cancellation of the event
              </ColoredText>
              .
            </Text>
          </>
        ),
      };
    case "DELETE":
      return {
        title: "Delete Event",
        buttonText: "Delete Event",
        onClick: handlers.onDelete,
        content: (
          <>
            <Text w="full">
              The event {kydEvent?.name} is currently{" "}
              <ColoredText color="green" mr={1}>
                live
              </ColoredText>
              with no sales
            </Text>
            <Text w="full" fontSize="sm">
              This action results in{" "}
              <ColoredText fontWeight={"bold"} color="kydRed.200">
                permanent deletion
              </ColoredText>
              .
            </Text>
          </>
        ),
      };
    default:
      return null;
  }
};

export const DangerZone = ({
  kydEvent,
  onArchive,
  onCancel,
  onDelete,
  loading,
}: DangerZoneProps) => {
  console.log("kydEvent", kydEvent?.status);
  if (kydEvent?.status === "ARCHIVED" || kydEvent?.status === "DELETED") {
    return null;
  }

  return (
    <Stack>
      <Text fontWeight={"bold"} width={"full"}>
        Danger Zone
      </Text>
      <Text fontSize="md">
        {`This section is where you make changes to your event that can't be reversed, please proceed with caution`}
      </Text>
      {kydEvent?.display_options?.delete_action?.length > 0 ? (
        <VStack
          borderWidth={1}
          borderColor="kydRed.200"
          borderRadius="md"
          w="full"
          p={4}
          gap={8}
        >
          {kydEvent.display_options.delete_action.map((action: string) => {
            const actionDetails = getActionDetails(action, kydEvent, {
              onArchive,
              onCancel,
              onDelete,
            });
            if (!actionDetails) return null;

            return (
              <RedButton
                key={action}
                show={true}
                title={actionDetails.title}
                buttonText={actionDetails.buttonText}
                onClick={actionDetails.onClick}
                loading={loading}
              >
                {actionDetails.content}
              </RedButton>
            );
          })}
        </VStack>
      ) : null}
    </Stack>
  );
};
